import Route from '@ember/routing/route';

export default class MobileHomeRoute extends Route {}
